import React from 'react';
import styles from './ErrorCard.module.css';
import { Icon } from 'antd';

const ErrorCard = props => (
  <center className={styles.Container}>
    <div className={styles.Content}>
      <Icon type="warning" className={styles.Icon} />
      <span className={styles.Span}>List not found.</span>
    </div>
  </center>
);

export default ErrorCard;



// WEBPACK FOOTER //
// ./src/components/UI/Error/ErrorCard.js